import React, { memo, useContext, useMemo } from 'react';
import { getContext, Symbols } from 'choerodon-ui/shared';
import ConfigContext from '../../../lib/config-provider/ConfigContext';
import { getConfig, getCustomizable, getPrefixCls, getProPrefixCls } from '../../../lib/configure/utils';
import { getTooltip, getTooltipTheme, getTooltipPlacement } from '../../../lib/_util/TooltipUtils';
const FormContext = getContext(Symbols.ProFormContext, {
    getConfig,
    getPrefixCls,
    getProPrefixCls,
    getCustomizable,
    getTooltip,
    getTooltipTheme,
    getTooltipPlacement,
});
const BaseFormProvider = function FormProvider(props) {
    const { children, value } = props;
    const { getConfig: getGlobalConfig, getPrefixCls: getGlobalPrefixCls, getProPrefixCls: getGlobalProPrefixCls, getCustomizable: getGlobalCustomizable, getTooltip: getGlobalTooltip, getTooltipTheme: getGlobalTooltipTheme, getTooltipPlacement: getGlobalTooltipPlacement, } = useContext(ConfigContext);
    const newValue = useMemo(() => ({
        ...value,
        getConfig: getGlobalConfig,
        getPrefixCls: getGlobalPrefixCls,
        getProPrefixCls: getGlobalProPrefixCls,
        getCustomizable: getGlobalCustomizable,
        getTooltip: getGlobalTooltip,
        getTooltipTheme: getGlobalTooltipTheme,
        getTooltipPlacement: getGlobalTooltipPlacement,
    }), [value, getGlobalConfig, getGlobalPrefixCls, getGlobalProPrefixCls, getGlobalCustomizable, getGlobalTooltip, getGlobalTooltipTheme, getGlobalTooltipPlacement]);
    return (React.createElement(FormContext.Provider, { value: newValue }, children));
};
BaseFormProvider.displayName = 'FormProvider';
export const FormProvider = memo(BaseFormProvider);
export default FormContext;
